<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineProps<{
  iconRight: IconDefinition
  iconLeft: IconDefinition
  label: string
  text: string
  to: RouteLocationRaw | undefined
}>()
</script>

<template>
  <NuxtLink :to="to" class="flex px-s pt-xs pb-m gap-xs items-center text-moss-100 no-underline group bg-surface-moss-elevated rounded-lg">
    <Icon :icon="iconLeft" class="hidden md:flex self-center" />
    <div class="flex-1 flex flex-col gap-3xs">
      <span class="title-xs font-normal">{{ label }}</span>
      <span class="text-xsmall !leading-[22px]">{{ text }} </span>
    </div>
    <div class="h-8 w-8 self-center group-hover:bg-moss-100 group-hover:text-moss-500 flex items-center justify-center rounded-md transition-all">
      <Icon :icon="iconRight" />
    </div>
  </NuxtLink>
</template>
